module.exports = __webpack_public_path__ + "static/media/cyberpass_bg.ba3402b6.jpg";